import { configureStore } from '@reduxjs/toolkit';
import forgotPasswordReducer from './forgotPasswordSlice';
import customerReducer from './customerSlice';
import vendorReducer from './vendorSlice'
import topcategoriesReducer from './home/topCategorySlice';
import categoriesReducer from './category/getAllCategorySlice'
import subcategoryReducer from './category/getSubcategoryslice'
import productsSlice from './productSlice'
import cartSlice from './cartSlice'
import scheduleSlice from './ScheduleSlice'
import compareSlice from './compareSlice'
import accountUserSlice from './AccountUserSlice'
import crossReferenceSlice from './crossreferenceSlice'
import appearencesSlice from './appearancesSlice'
import bomSlice from './bomSlice'
import recievedEnquirySlice from './recievedEnquiriesSlice'
import poorderSlice from './poorderSlice'
import wizardSlice from './wizardSlice'
import recievedOrderSlice from './receivedVendorOrderSlice'
import excessSlice from './excessSlice'
import scheduleOrderSlice from './scheduleOrderSlice'
import  notificationSlice  from './notification';
import getSimilarProductSlice from './similarProductsSlice'
const store = configureStore({
    reducer: {
        forgotPassword: forgotPasswordReducer,
        customer: customerReducer,
        vendor:vendorReducer,
        topcategories: topcategoriesReducer,
        categories:categoriesReducer,
        subCategories : subcategoryReducer,
        products:productsSlice,
        similarproducts:getSimilarProductSlice,
        cart:cartSlice,
        schedule:scheduleSlice,
        compare:compareSlice,
        accountUser:accountUserSlice,
        crossReference:crossReferenceSlice,
        appearences:appearencesSlice,
        bom:bomSlice,
        recievedEnquiries:recievedEnquirySlice,
        receivedOrders:recievedOrderSlice,
        poorder:poorderSlice,
        wizard:wizardSlice,
        excess:excessSlice,
        scheduleOrder:scheduleOrderSlice,
        notification:notificationSlice
    }
});

export default store;
